import "suneditor/dist/css/suneditor.min.css";
import SunEditor from "suneditor-react";
import React, { useRef, useImperativeHandle, forwardRef } from "react";
import SunEditorCore from "suneditor/src/lib/core";

interface EditorProps {
  onChange: (c: string) => void;
  defaultValue?: string;
}

export interface EditorHandle {
  insertHtml: (html: string) => void;
  getContents: () => string;
  setContents: (html: string) => void;
}

const options = {
  buttonList: [
    ["undo", "redo", "font", "fontSize", "formatBlock"],
    [
      "bold",
      "underline",
      "italic",
      "strike",
      "subscript",
      "superscript",
      "removeFormat",
    ],
    [
      "fontColor",
      "hiliteColor",
      "outdent",
      "indent",
      "align",
      "horizontalRule",
      "list",
      "table",
    ],
    [
      "link",
      "image",
      "video",
      "fullScreen",
      "showBlocks",
      "codeView",
      "preview",
      "print",
      "save",
    ],
  ],
  attributesWhitelist: {
    all: "style|class|id",
    audio: "src|controls|autoplay|loop|muted",
    source: "src|type",
    a: "href|target|download|rel|title|alt",
    div: "style|class",
  },
  pasteTagsWhitelist: "audio|source|div|p|br|span|strong|em|a|img|ul|li|ol",
};

export const Editor = forwardRef<EditorHandle, EditorProps>(
  ({ onChange, defaultValue }, ref) => {
    const editorRef = useRef<SunEditorCore>();

    useImperativeHandle(ref, () => ({
      insertHtml: (html: string) => {
        editorRef.current?.insertHTML(html);
      },
      getContents: () => {
        return editorRef.current?.getContents(false) || "";
      },
      setContents: (html: string) => {
        editorRef.current?.setContents(html);
      },
    }));

    return (
      <>
        <SunEditor
          getSunEditorInstance={(editor) => {
            editorRef.current = editor;
          }}
          defaultValue={defaultValue}
          onChange={(c) => onChange(c)}
          height="100%"
          setOptions={options}
        />
      </>
    );
  }
);

Editor.displayName = "Editor";
